module.exports = __webpack_public_path__ + "static/media/woman_search_file.2492713e.svg";